import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import BookTimePicker from './BookTimePicker';
import ClinicianCard from '../../../components/common/ClinicianCard';
import FeeSummary from '../../../components/NewBooking/FeeSummary';
import { Card, CardBody } from '../../../components/common/Card';
import analytics from '../../../infra/analytics';

const DateSelector = () => {
  const workflow = useSelector(({ workflow }) => workflow.data);
  const { specialist } = workflow;
  const { workflowId } = useParams();

  useEffect(() => {
    analytics.logPageViewEvent('select_booking_date', {
      workflow_id: workflowId,
    });
  }, [workflowId]);

  return (
    <>
      <Card>
        <CardBody>
          <ClinicianCard specialist={specialist} />
        </CardBody>
      </Card>

      <FeeSummary fee={specialist?.fee} />

      <BookTimePicker />
    </>
  );
};

export default DateSelector;
